import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ENTERPRISE_DEMO_IEAM_3 = {
  title:
    "Capturing customer intent and\n applicable network services \n for software deployment",
  subtitle: "Enterprise demo",
  text: "The customer intent is captured along with the\nchoice of Edge server and network services \n which are applicable for the software.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_114"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_112"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Enterprise_demo_screens_01.png",
  rightSideImage: "ENG/IEAM/IEAM_Enterprise_demo_screens_03.png",
};
